/**
 * Меню раздела "Ресурсы". Модуль для работы с API.
 * Содержит структуру папок-разделов и конечных элементов-ссылок на страницы со списком объектов конкретного описателя.
 * @module definitionsMenu
 */

/**
 * Получение структуры меню для раздела "Ресурсы"
 * @returns {Promise<Array>} - структура меню
 * @throws {Error} - ошибка при получении данных
 */
export const getMenu = async () => {
  try {
    const response = await fetch(`/api/definitionsmenu`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.menu;
  } catch (err) {
    throw err;
  }
};

/**
 * Создание папки
 * @param {Object} item - данные папки
 * @param {string} item.name - название папки
 * @param {string} item.parent - uuid родительской папки
 * @returns {Promise<Object>} - созданная папка
 * @throws {Error} - ошибка при создании данных
 */
export const createFolder = async (item) => {
  try {
    const response = await fetch("/api/definitionsmenu/folder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление папки
 * @param {Object} item - данные папки
 * @param {string} item.uuid - uuid папки
 * @param {string} item.name - название папки
 * @returns {Promise<Object>} - обновленная папка
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateFolder = async (item) => {
  try {
    const response = await fetch("/api/definitionsmenu/folder", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление папки
 * @param {Object} item - данные папки
 * @param {string} item.uuid - uuid папки
 * @returns {Promise<Object>} - удаленная папка
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteMenuItem = async (item) => {
  try {
    const response = await fetch("/api/definitionsmenu", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Задать расположение описателю в меню (выбрать ему папку)
 * @param {Object} item - данные пары
 * @param {string} item.parent - uuid родительской папки
 * @param {string} item.child - uuid описателя
 * @returns {Promise<Object>} - обновленный описатель
 * @throws {Error} - ошибка при обновлении данных
 */
export const setDefinitionIntoMenu = async (item) => {
  try {
    const response = await fetch("/api/definitionsmenu/object", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error("Ошибка при добавлении данных. Попробуйте снова.");
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};
